import { DataTable } from '../../models';

export const trimMetricTable = (metricTable: DataTable, numberOfPoints: number) => {
  return metricTable.slice(-numberOfPoints);
};
